import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { z } from "zod";
import { requiredTranslatableZodSchema } from "../../translations/translation";
import { storageItemIdZodSchema } from "../storage-item-id";

const storageItemReferenceBaseZodObject = z.object({
    _type: z.literal("STORAGE_ITEM_REFERENCE"),
    _createdAt: isoAndUnixZodSchema,
    title: requiredTranslatableZodSchema,
    path: z.string(),
    storageItemId: storageItemIdZodSchema,
    tags: z.record(z.string(), z.boolean()),
});
type _StorageItemReferenceBase = z.infer<
    typeof storageItemReferenceBaseZodObject
>;
const storageItemReferenceBaseZodSchema: z.ZodSchema<_StorageItemReferenceBase> =
    storageItemReferenceBaseZodObject;

export { storageItemReferenceBaseZodObject, storageItemReferenceBaseZodSchema };
export type { _StorageItemReferenceBase };
